export default __webpack_public_path__ + "static/kevinLovePortrait-27e61585b73ccf885a70833ca183d6ae.png";